import React, { useContext, useCallback } from "react"
import { MenuItemProps, MenuItem } from "@blueprintjs/core"
import { ActionItemContext, ActionItemContextProps } from "./ActionMenu"
import { isString } from "lodash-es"

interface ActionMenuItemProps extends Omit<MenuItemProps, "onClick"> {
  /**
   * a property to uniquely identify this item
   * @default icon
   */
  id?: string
  /**
   * this handler is called by default whenever a menu item is clicked
   * it has an argument id, which is basically the icon property passed to the component be default
   * or the user can also assign his own key by using the 'id' property
   */
}
const ActionMenuItem = ({ id, icon, ...otherProps }: ActionMenuItemProps) => {
  const { onClick } = useContext<ActionItemContextProps>(ActionItemContext)
  //Create a memoised callback so it does not create new instances everytime the component is rendered
  const handleClick = useCallback(
    () => onClick && onClick(id ? id : isString(icon) ? icon : ""),
    [id, icon, onClick]
  )
  return <MenuItem {...otherProps} icon={icon} id={id} onClick={handleClick} />
}

export default ActionMenuItem
